import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge conditional class names and de-duplicate conflicting Tailwind utilities.
 * Shared by every Tailwind-styled surface in admin v2.
 *
 * tailwind-merge v3 natively handles Tailwind v4 custom color tokens defined
 * under the --color-* namespace (e.g. text-foreground, bg-card, text-primary)
 * via its built-in permissive color validator — no extra configuration needed.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
